/** handle most of api connections */
import config from './config.js'
import * as utils from './utils.js'
import { HttpService } from './http-service.js';
import * as events from './events.js';
import * as ui from './ui.js';

const urldbHost = config.dbHost.hosts[0]._dbHost;
const authdbHost = config.dbHost.hosts[0]._dbAuth;
const navigator = window.navigator;


/**
 * featch if the user blocked or not by ip service 
 * @param {string} ip 
 * @returns json response if this ip fake or real
 */
// fix this method not return result
export async function fetchUserBlockStatus(ip) {
  try {
    const ipApi = config.dbHost.ipApi;

    const response = await fetch(`${urldbHost}${ipApi}?ip=${ip}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: authdbHost
      }
    });

    const text = await response.text();

    if (!text.trim()) {
      console.warn("API returned empty body");
      return null;
    }

    return JSON.parse(text);

  } catch (err) {
    console.error("fetchUserBlockStatus error:", err);
    return null;
  }
}

export function fetchUserMessages() {
  fetchReplies(config.sessionid)
    .then(data => {
      if (data.reply && data.reply.length > 0) {
        ui.displayMessages(data.reply);
      } else {
        ui.displayMessages([]); // Display "No messages found"
      }
    })
    .catch(error => {
      console.error('Error fetching messages:', error);
      document.getElementById('messages-list').innerHTML = `
                    <div class="list-group-item text-center text-muted">
                        Failed to load messages.
                    </div>`;
    });
}
/**
 * 
 * @param {object} logUser 
 * @returns 
 */
export async function logUsersOfDesign(logUser) {
  const requestUrl = urldbHost + config.dbHost.dbApi;
  try {
    const response = await fetch(requestUrl, {
      method: "POST",
      headers: {
        Authorization: authdbHost,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(logUser),
    });

    if (!response.ok) {
      throw new Error(`Network response was not ok: ${response.status} ${response.statusText}`);
    }


    return response; // or return response.json() if you need the body
  }
  catch (error) {

    console.log(error);
    return null;
  }
}
/** this function fetch api so we add it here */
/**
 * 
 * @param {string} designname 
 * @param {string} imageuploaded 
 * @param {string} imagedesigned 
 * @param {string} dotnethost 
 * @param {string} names 
 * @param {string} ref 
 * @param {object} dataCloud 
 * @returns 
 */
export async function logUsers(designname, imageuploaded, imagedesigned, dotnethost, names, ref, dataCloud = null) {
  if (window.location.origin.indexOf('localhost') != -1) {
    return;
  };


  let requestUrl = urldbHost + config.dbHost.dbApi;
  let nmlist = "";
  // if(isiPhone()){
  //   nmlist =  decodeURI(names);
  // }else{
  nmlist = decodeURI(names);
  //}
  let cookieIp = utils.getCookie("ip");
  let cookieCountry = utils.getCookie("country");

  let device = navigator.userAgent;
  if (cookieIp && cookieCountry) {
    dataCloud = { ip: cookieIp, loc: cookieCountry, uag: device };
  }
  if (dataCloud != null) {
    let logUser = {
      logDownloadUser: "y",
      userip: dataCloud.ip,
      countryCode: dataCloud.loc,
      deviceinfo: dataCloud.uag,
      ispwa: config.isPWA,
      domainurl: config.domain,
      design: designname,
      dotnetHost: dotnethost,
      uploadedImage: imageuploaded,
      designedImage: imagedesigned,
      namelist: nmlist,
      ref: config.ref,
      sessionid: config.sessionid
    };
    let _totalDownload = utils.getCookie(config.totaldowloadKey);
    let _totalDesigns = utils.getCookie(config.designName);
    logUser.totalDownload = _totalDownload != null ? _totalDownload : 0;
    logUser.totalDesigns = _totalDesigns != null ? _totalDesigns : 0;
    logUsersOfDesign(logUser);
    return;
  }

  return await new Promise(function (resolve, reject) {
    fetch("https://www.cloudflare.com/cdn-cgi/trace")
      .then(response => response.text())
      .then(data => {
        data = data.trim().split("\n").reduce((obj, pair) => {
          pair = pair.split("=");
          obj[pair[0]] = pair[1];
          return obj;
        }, {});

        const ip = data.ip;
        const country = data.loc;
        const device = data.uag;

        let logUser = {
          logDownloadUser: "y",
          userip: ip,
          countryCode: country,
          deviceinfo: device,
          ispwa: config.isPWA,
          domainurl: config.domain,
          design: designname,
          dotnetHost: dotnethost,
          uploadedImage: imageuploaded,
          designedImage: imagedesigned,
          namelist: nmlist,
          ref: config.ref,
          sessionid: config.sessionid
        };
        return fetch(`${requestUrl}`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `${authdbHost.dbAuth}`
          },
          body: JSON.stringify(logUser)
        });
      })
      .then(response => response.text())
      .then(response => {
        resolve(response);
      })
      .catch(err => {
        reject(err);
      });
  });
}

/**
 * Fetch Facebook shares count safely
 * Returns: { count: number } or { count: 0 } on any error
 */
export async function fetchSharesCount() {
  const postId = settingData?.general?.fbpostid;
  const profileId = config?.profileId;
  const accessToken = config?.ac;

  // Safety checks
  if (!postId || !profileId || !accessToken) {
    console.warn("Missing FB post ID or access token");
    return { shares: { count: 0 } };
  }

  const url = `https://graph.facebook.com/v20.0/${profileId}_${postId}?fields=shares&access_token=${accessToken}`;

  try {
    const response = await fetch(url, {
      method: "GET",
      cache: "no-cache", // optional: always fresh count
    });

    if (!response.ok) {
      console.warn(`FB API error: ${response.status} ${response.statusText}`);
      return { shares: { count: 0 } };
    }

    const data = await response.json();

    // Facebook returns: { shares: { count: 123 } } or just { id: "..." } if no shares
    return {
      shares: {
        count: data.shares?.count ?? 0
      }
    };

  } catch (error) {
    console.error("Failed to fetch FB shares:", error);
    return { shares: { count: 0 } }; // Never crash
  }
}

/**
 * Simple wrapper - returns just the number
 */
export async function getCurrentShareCount() {
  try {
    const result = await fetchSharesCount();
    return result.shares?.count ?? 0;
  } catch (err) {
    return 0; // Always return a number
  }
}

/**
 * Submit data of survey to api
 */
export async function submitSurvey(data) {


  await fetch(`${urldbHost}${config.dbHost.reviewApi}`, {
    method: "POST",
    headers: { "Content-Type": "application/json", Authorization: `${authdbHost}` },
    body: JSON.stringify(data)
  }).then(() => {

  });
}
/**
 * submit to FriendShared
 */
export async function submitSendToFriend(data) {


  try {
    const response = await fetch(`${urldbHost}${config.dbHost.friendApi}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `${authdbHost}`
      },
      body: JSON.stringify(data)
    });

    if (!response.ok) {
      throw new Error(`API Error: ${response.status}`);
    }

    const result = await response.json();
    return result;

  } catch (error) {
    console.error("submitSendToFriend error:", error);
    return null; // Or rethrow or handle as needed
  }
}
export async function getUrlDetails(myqueryParams, type = 'image') {
  return await new Promise(function (resolve, reject) {
    // test local 
    let params = utils.getDataFromSessionStorage();
    if (params == null) {
      params = new URLSearchParams(window.location.search);
    }
    if (config.testMode) {
      //let params = new URLSearchParams(window.location.search);
      let hostUrl = "http://localhost:5000";
      // let hostUrl = "https://api.tasawehala.com";
      let auth = "";
      let videoApi = params.has("vdtype") ? '/api/Video/' : '/api/tasadesign/';
      if (type == "image") {
        resolve([hostUrl + '/api/tasadesign/' + myqueryParams, auth, hostUrl]);
      } else {
        resolve([hostUrl + videoApi + myqueryParams, auth, hostUrl]);
      }
      return;
    }
    // when change the dll app return only one host until we change the other and disable get the current
    // hot from getLoadBalancer method
    if (config.changeBalancerMode) {
      // let params = new URLSearchParams(window.location.search);
      let index = utils.getRandomInt(0, 5); // use the first host only
      let service = utils.getCurrentUrl(index, type);
      let hostUrl = service.url;
      let auth = service.auth;
      let videoApi = params.has("vdtype") ? '/api/Video/' : '/api/tasadesign/';
      if (type == "image") {
        resolve([hostUrl + '/api/tasadesign/' + myqueryParams, auth, hostUrl]);
      } else {
        resolve([hostUrl + videoApi + myqueryParams, auth, hostUrl]);
      }
      return;
    }
    // normal case get the result from balancer
    utils.getLoadBalancer(type).then(response => {

      // let params = new URLSearchParams(window.location.search);
      let index = response;

      let service = utils.getCurrentUrl(Number(index), type);
      let hostUrl = service.url;
      let auth = service.auth;
      let videoApi = params.has("vdtype") ? '/api/Video/' : '/api/tasadesign/';
      if (type == "image") {
        resolve([hostUrl + '/api/tasadesign/' + myqueryParams, auth, hostUrl]);
      } else {
        resolve([hostUrl + videoApi + myqueryParams, auth, hostUrl]);
      }
    });

  });
}
export async function sendHttpService(settingData, urlDetails, dataCloud) {
  let httpService = new HttpService(urlDetails);
  //let params = new URLSearchParams(window.location.search);
  let params = utils.getDataFromSessionStorage();
  if (params == null) {
    params = new URLSearchParams(window.location.search);
  }
  let fn = params.has('fn');
  let vdtype = params.has('vdtype');
  const designType = settingData.general.design;
  if (!fn && !vdtype) {
    // method is get
    await httpService.getRequest().then(function (data) {
      if (designType == "image") {
        utils.saveCurrentDesign(data);
        config.domain = urlDetails[2]; // change to domain
        events.fireImagedesignedSuccess(settingData, data, urlDetails[2], false, dataCloud);
      } else {

        utils.saveCurrentDesign(data, 'video');

        events.fireVideoDesignedSuccess(settingData, data, null, false);
      }
    });
  } else {

    // method is post
    let obj = preparePayload(settingData);
    //console.log(obj);

    httpService.payload = obj;
    httpService.postRequest().then(function (data) {

      if (config.designType == "image") {
        utils.saveCurrentDesign(data);
        config.domain = urlDetails[2]; // change to domain
        events.fireImagedesignedSuccess(settingData, data, urlDetails[2], false, dataCloud);
      } else {
        utils.saveCurrentDesign(data, 'video');
        events.fireVideoDesignedSuccess(settingData, data, null, false);
      }
    });
  }
}
export function preparePayload(settingData) {
  //let params = new URLSearchParams(window.location.search);
  let params = utils.getDataFromSessionStorage();

  if (params == null) {
    params = new URLSearchParams(window.location.search);
  }
  let fn = params.has('fn');
  // if(fn == false && designType =='image')
  //     return null;

  let title = params.get("title");
  let jsonObject = null;
  const fileRaws = [];
  let imageSystem = params.get('imagesystem');
  let ct = config.ct;
  if (config.ct != "") {
    ct = ct.replace(/"/g, '\"');
  }
  let imagesCount = 1;
  let isUploadImage = true;
  if (settingData.general.type != "uploadPhotos") {
    //you can validate here
    isUploadImage = false;
  }
  if (settingData.general.uploadCount != undefined) {
    if (settingData.general.uploadCount == 0)
      settingData.general.uploadCount = 1;
    imagesCount = settingData.general.uploadCount;
  }
  for (var index = 0; index < imagesCount; index++) {
    var img = localStorage.getItem(`img${index}`)
    if (img != undefined) {
      fileRaws.push({ Raw: img, Name: `image${index + 1}`, FileName: "", FileType: "Image" });
      // remove it
      // localStorage.removeItem(`img${index}`)
    }
  }

  // test option create manual object for testing only
  // let options = {imageSystem : "pv3" , "designTexts" :[ {Name :"Title" , FontHexaColor : "#ff0"}]};

  jsonObject = {
    FileRaw: isUploadImage ? fileRaws : [],
    DesignName: config.designName,
    imageSystem: imageSystem,
    Title: title,
    Ct: ct
  }
  config.cacheObject = jsonObject;
  return jsonObject;
}
export async function fetchReplies(sid, msgId) {
  let urlMessageApi = config.dbHost.messageApi;
  let readMessagesUrl = `${urldbHost}${urlMessageApi}?sid=${sid}`;
  let readRepliesUrl = `${urldbHost}${urlMessageApi}?sid=${sid}&msgId=${msgId}`;

  return fetch(msgId != undefined ? readRepliesUrl : readMessagesUrl, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `${authdbHost}`
    }
  }).then(res => res.json());

}
/**
 * 
 * @param {object} data 
 */
export async function submitContact(data) {
  const contacAPi = config.dbHost.contactApi;
  const url = `${urldbHost}${contacAPi}`;

  try {
    // When the payload carries a raw audio file, gather every field
    // into multipart form data; plain text messages stay JSON.
    const hasAudio = !!(data && data.audio instanceof Blob);
    let body = data;
    if (hasAudio) {
      const formData = new FormData();
      formData.append("name", data.name || "");
      formData.append("email", data.email || "");
      formData.append("sessionId", data.sessionId || "");
      formData.append("message", data.message || "");
      // Name the file from the same mime map the PHP side uses, so a
      // WAV recording is sent as .wav (never mislabelled as .webm).
      const mime = (data.audio.type || "").split(";")[0].trim().toLowerCase();
      const extByMime = {
        "audio/webm": "webm",
        "audio/ogg": "ogg",
        "audio/mp4": "m4a",
        "audio/mpeg": "mp3",
        "audio/wav": "wav",
        "audio/x-wav": "wav",
      };
      const ext = extByMime[mime] || "webm";
      formData.append("audio", data.audio, "contact-audio." + ext);
      body = formData;
    } else {
      body = JSON.stringify(data);
    }
    const response = await fetch(url, {
      method: "POST",
      headers: {
        ...(hasAudio ? {} : { "Content-Type": "application/json" }),
        Authorization: authdbHost, // assuming authdbHost is already a Bearer token or similar
      },
      body,
    });

    // Optional: parse JSON only if response is ok and content-type is json
    let responseData;
    const contentType = response.headers.get("content-type");
    if (contentType && contentType.includes("application/json")) {
      responseData = await response.json();
    }

    if (response.ok) {
      // 200–299
      return {
        success: true,
        data: responseData || null,
        status: response.status,
      };
    } else {
      // 4xx, 5xx
      return {
        success: false,
        error: responseData?.message || response.statusText || "Unknown error",
        status: response.status,
      };
    }
  } catch (error) {
    // Network error, timeout, etc.
    return {
      success: false,
      error: error.message || "Network error",
    };
  }
}
